import React, { ReactElement } from 'react';

import * as S from './SocialCard.styles';

type SocialCardProps = {
  description: string;
  profileImageUrl: string;
  username: string;
  name: string;
}

export const SocialCard = ({ description, profileImageUrl, username, name }: SocialCardProps): ReactElement => {
  return (
    <S.Wrapper>
      <S.Description dangerouslySetInnerHTML={{ __html: description }} />

      <S.SocialWrapper>
        <S.Image src={profileImageUrl} />
        <S.SocialTextWrapper>
          <S.SocialName>{name}</S.SocialName>
          <S.SocialUsername>{username}</S.SocialUsername>
        </S.SocialTextWrapper>
      </S.SocialWrapper>
    </S.Wrapper>
  );
};
